import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import '../App.css';

function NotFound() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container className="not-found">
      <h1>Page not found</h1>
      <p className="not-found__text">
        That URL does not exist on this site. Try one of these pages instead.
      </p>
      <ul className="not-found__links">
        <li>
          <Link to="/">Home</Link>
        </li>
        <li>
          <Link to="/aboutMe">About</Link>
        </li>
        <li>
          <Link to="/services">Services</Link>
        </li>
        <li>
          <Link to="/portfolio">Portfolio</Link>
        </li>
        <li>
          <Link to="/manifesto">Manifesto</Link>
        </li>
        <li>
          <Link to="/contact">Contact</Link>
        </li>
      </ul>
    </Container>
  );
}

export default NotFound;
